export default {
  codeBlank: 'Please enter the code sent to your email.',
  codeLength: 'The code should be six characters long.',
  codeNumeric: 'The code should only contain numbers (0-9).',
  emailNotFound: 'Something went wrong during multi-factor authentication.',
} as const;
